import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  phoneNumber: '',
  route: "missions",
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
    setRoute(state, action) {
      state.route = action.payload;
    },
  },
});

export const { setPhoneNumber, setRoute } = globalSlice.actions;
export default globalSlice.reducer;
